import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { ProgressBar } from "./ProgressBar";
import { SAFETY_OPTIONS } from "../data/quiz";

const containerVariants = {
  enter: { opacity: 0, x: 48 },
  center: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -48 },
};

export const QuestionScreen = ({ question, index, total, selectedId, onSelect }) => {
  const isSafety = question.section === "safety";
  const options = isSafety ? SAFETY_OPTIONS : question.options;

  return (
    <motion.div
      key={question.id}
      variants={containerVariants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      className="flex flex-1 flex-col"
      data-testid={`question-screen-${question.id}`}
    >
      <ProgressBar current={index + 1} total={total} />

      {isSafety && (
        <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-coral">
          Prima di iniziare
        </p>
      )}

      <h2 className="font-serif text-2xl font-semibold leading-snug text-ink">
        {question.text}
      </h2>
      {question.subtitle && (
        <p className="mt-2 text-sm text-ink/55" data-testid="question-subtitle">
          {question.subtitle}
        </p>
      )}

      <div className="mt-8 flex flex-col gap-3" data-testid="options-list">
        {options.map((opt, i) => {
          const selected = selectedId === opt.id;
          return (
            <motion.button
              key={opt.id}
              type="button"
              onClick={() => onSelect(opt)}
              data-testid={`option-${question.id}-${opt.id}`}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.06 * i, ease: "easeOut" }}
              className={`group flex items-center justify-between rounded-2xl border-2 bg-white/70 px-5 py-4 text-left transition-all duration-200 hover:border-coral/60 ${
                selected
                  ? "border-coral bg-coral-soft"
                  : "border-transparent shadow-sm"
              }`}
            >
              <span className="flex flex-col">
                <span className="text-base font-medium text-ink">{opt.label}</span>
                {opt.hint && (
                  <span className="mt-0.5 text-xs text-ink/45">{opt.hint}</span>
                )}
              </span>
              <span
                className={`ml-4 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 transition-colors duration-200 ${
                  selected ? "border-coral bg-coral text-white" : "border-ink/20 text-transparent"
                }`}
              >
                <Check size={14} strokeWidth={3} />
              </span>
            </motion.button>
          );
        })}
      </div>
    </motion.div>
  );
};
